<template>
	<b-form
		ref="form"
		@submit.prevent="setEscapementPost"
	>
		<b-form-group>
			<v-select
				v-model="escapement"
				label="Name"
				:options="escapements"
			/>
		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Add Escapement</b-button>

	</b-form>
</template>

<script>
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import EscapementService from "@/api-services/escapement.service";

export default {
	name: "SetEscapement",

	// things we want to use
	components: {
		VSelect
	},

	// data we bind to, escapements need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			escapement: null,
			escapements: []
		};
	},

	created() {
		this.fetchEscapements();
	},

	// things we do to data
	methods: {
		setEscapementPost() {
			this.$emit("add", this.escapement);
		},

		fetchEscapements() {
			EscapementService.getAll().then(response => {
				this.escapements = response.data;
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/set-escapement.vue